import NextImage from 'next/image';
import styled from 'styled-components';

export const StyledImage = styled(NextImage)`
  display: block;
  background-color: ${({ theme }) => theme.colors.brandGray200};
  height: auto;
`;
